/**
 * Adds 0 as prefix to [0-9] numbers.
 */
export const addLeadingZero = (num: number): string => {
    return num?.toString()?.padStart(2, "0") ?? "0";
}
